/* This file was created automatically, don't change it manually. */

import React, { forwardRef } from 'react';

import { ColorlessIconProps } from '../../types';
import { SVGContainer } from '../../SVGContainer';

const IconChat12 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconChat12(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 12 12" ref={ref}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="m5.124 8.461.449.027c.14.008.282.012.427.012 1.237 0 2.259-.3 2.943-.805C9.593 7.217 10 6.515 10 5.5s-.408-1.717-1.057-2.195C8.26 2.801 7.237 2.5 6 2.5s-2.259.3-2.943.805C2.407 3.783 2 4.485 2 5.5c0 1.183.556 1.969 1.468 2.452L4 8.234V9.75l1.124-1.289Zm.39 1.025c.16.01.322.014.486.014 2.764 0 5-1.333 5-4s-2.236-4-5-4-5 1.333-5 4c0 1.58.785 2.692 2 3.336V11h1l1.514-1.514Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconChat16 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconChat16(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 16 16" ref={ref}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="m6.833 11.282.598.035c.186.01.376.016.57.016 1.65 0 3.011-.4 3.924-1.073.865-.638 1.409-1.573 1.409-2.927 0-1.353-.544-2.288-1.41-2.926-.912-.673-2.274-1.074-3.923-1.074-1.65 0-3.012.401-3.924 1.074-.866.638-1.41 1.573-1.41 2.926 0 1.577.741 2.625 1.958 3.27l.709.376V13l1.5-1.718Zm.52 1.366c.213.012.43.019.648.019 3.684 0 6.666-1.778 6.666-5.334C14.667 3.778 11.685 2 8.001 2 4.316 2 1.334 3.778 1.334 7.333c0 2.107 1.047 3.59 2.667 4.448v2.886h1.333l2.019-2.02Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconChat24 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconChat24(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 24 24" ref={ref}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="m10.249 16.923.896.052c.28.017.565.025.855.025 2.474 0 4.517-.601 5.886-1.61C19.185 14.433 20 13.03 20 11s-.815-3.433-2.114-4.39C16.517 5.601 14.474 5 12 5s-4.517.601-5.886 1.61C4.815 7.567 4 8.97 4 11c0 2.365 1.112 3.938 2.937 4.905L8 16.468V19.5l2.249-2.577Zm.78 2.049c.319.019.643.028.971.028 5.527 0 10-2.667 10-8s-4.473-8-10-8S2 5.667 2 11c0 3.16 1.57 5.384 4 6.672V22h2l3.028-3.028Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

export const IconChat = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconChat(props, ref) {
    const { size = '16', role = 'supplementary' } = props;

    const iconProps = {
        ...props,
        size,
        ref,
        role,
        colorless: true,
    } as const;

    switch (size) {
        case '12':
            return <IconChat12 {...iconProps} />;
        case '16':
            return <IconChat16 {...iconProps} />;
        case '24':
            return <IconChat24 {...iconProps} />;
        default:
            return <IconChat24 {...iconProps} />;
    }
});
